import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.sm + spacing.xs,
	},
	fieldLabel: {
		color: colors.text.dark,
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.xs,
	},
	fieldContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
});
